// 初回表示中だけ、装飾・メディア側の処理を休止するための共有状態。
export function createRevealActivity() {
  let active = false;
  let destroyed = false;
  const listeners = new Set();
  return {
    get active() { return active; },
    setActive(value) {
      if (destroyed || active === value) return;
      active = value;
      listeners.forEach((listener) => listener(active));
    },
    subscribe(listener) {
      if (destroyed) return () => {};
      listeners.add(listener);
      listener(active);
      return () => listeners.delete(listener);
    },
    destroy() { destroyed = true; listeners.clear(); },
  };
}
